<template>
	<div class="app-container">
		<!-- 顶部标题栏 -->
		<div class="header-bar">
			<button @click="goBack" class="back-btn"><i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i></button>
			<div class="title-center">
				<div class="main-title">{{ $t('certification.selectCertType') }}</div>
			</div>
			<div class="header-right"></div>
		</div>

		<!-- 背景图（模糊） -->
		<div class="bg-image"></div>

		<!-- 内容区域 -->
		<div class="content-wrapper">
			<!-- VIP横幅 -->
			<div class="vip-banner">
				<div class="vip-text">VIP</div>
				<div class="vip-icon"></div>
			</div>

			<!-- 中间内容容器（灰色半透明背景） -->
			<div class="middle-container">
				<!-- 官方合作数据按钮 -->
				<button class="official-btn">
					<span class="official-icon"></span>
					<span class="official-text">{{ $t('certification.officialData') }}</span>
				</button>

				<!-- 认证选项网格 -->
				<div class="certification-grid">
					<div 
						v-for="(item, index) in certificationTypes" 
						:key="index"
						class="cert-item"
						:class="{ 
							active: selectedType === item.type,
							disabled: !availableTypes.includes(item.type)
						}"
						@click="selectType(item.type)"
					>
						<div class="cert-icon">{{ item.icon }}</div>
						<div class="cert-text">{{ item.text }}</div>
					</div>
				</div>

			</div>
		<!-- 在线匹配 -->
		<div class="online-match">
			<span class="location-icon"><svg t="1768703763025" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29611" width="32" height="32"><path d="M677 223.42A236 236 0 0 0 511.41 156c-129.3 0-234.23 103.1-234.23 230.41 0 158.31 179.25 322 179.25 322 34.39 31.94 77.48 29.36 108.37-0.14 0 0 180.83-154.93 180.83-321.86A228.3 228.3 0 0 0 677 223.42zM511.33 481.75A104.67 104.67 0 1 1 616 377.08a104.67 104.67 0 0 1-104.67 104.67z" fill="#F43D3D" p-id="29612"></path><path d="M321.89 651.13h-98.38a30.5 30.5 0 0 0-28.73 20.28l-48.42 136.3a30.48 30.48 0 0 0 28.72 40.69h672.65a30.49 30.49 0 0 0 28.73-40.69L828 671.41a30.5 30.5 0 0 0-28.73-20.28H700.1a29.31 29.31 0 0 0-21.91 9.87l-69.34 77.91c-51.93 58.35-143.08 58.46-195.15 0.24l-69.94-78.21a29.36 29.36 0 0 0-21.87-9.81z" fill="#F77F7F" p-id="29613"></path></svg></span>
			<span class="match-text">{{ $t('certification.onlineMatch') }}</span>
		</div>	
			<!-- 下一步按钮 -->
			<button class="next-btn" @click="goNext">
				{{ $t('certification.nextStep') }}
			</button>
		</div>
		
		
		<!-- 底部导航栏 -->
		<!-- <div class="footer-nav">
			<button 
				v-for="tab in tabs" 
				:key="tab.name" 
				@click="switchTab(tab.name)" 
				class="nav-item" 
				:class="{ active: activeTab === tab.name }"
			>
				<div class="nav-icon">{{ tab.icon }}</div>
				<div class="nav-text">{{ tab.text }}</div>
			</button>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'CertificationTypeSelect',
	data() {
		return {
			selectedType: null, // 根据订单进度自动选择
			activeTab: 'square',
			beautyId: null,
			currentOrder: null, // 当前订单信息
			orderSteps: [], // 订单步骤信息
			availableTypes: [], // 可选的认证类型
			certificationTypes: [],
			tabs: []
		}
	},
	mounted() {
		// 初始化认证类型
		this.certificationTypes = [
			{ type: 'car', icon: '', text: this.$t('certification.carCert') },
			{ type: 'hotel', icon: '', text: this.$t('certification.hotelCert') },
			{ type: 'confidential', icon: '️', text: this.$t('certification.confidentialCert') }
		]
		// 初始化tabs
		this.tabs = [
			{ name: 'info', icon: 'ℹ️', text: this.$t('common.info') || '信息' },
			{ name: 'video', icon: '▶️', text: this.$t('common.video') || '视频' },
			{ name: 'square', icon: '❤️', text: this.$t('common.square') || '广场' },
			{ name: 'auth', icon: '⭐', text: this.$t('common.auth') || '认证' },
			{ name: 'my', icon: '', text: this.$t('common.my') || '我的' }
		]
		// 获取传递的美女ID
		this.beautyId = this.$route.query.id || this.$route.query.beautyId
		if (!this.beautyId) {
			this.$toast.fail(this.$t('profile.missingParams'))
			this.goBack()
		}
		// 获取当前订单信息，根据订单进度判断应该选择哪个认证类型
		this.getCurrentOrder()
	},
	methods: {
		goBack() {
			return window.history.back()
		},
		getCurrentOrder() {
			// 获取当前订单信息（需要传递beauty_id，每个美女的订单是独立的）
			if (!this.beautyId) {
				return
			}
			this.$http({
				method: 'get',
				url: 'get_current_order',
				data: { beauty_id: this.beautyId }
			}).then(res => {
				if (res.code === 200 && res.data) {
					this.currentOrder = res.data
					this.orderSteps = res.data.steps || []
					// 根据订单进度判断应该选择哪个认证类型
					this.determineCurrentCertType()
				} else {
					// 没有订单，默认选择车费认证
					this.selectedType = 'car'
					this.availableTypes = ['car']
				}
			}).catch(() => {
				// 获取订单失败，默认选择车费认证
				this.selectedType = 'car'
				this.availableTypes = ['car']
			})
		},
		determineCurrentCertType() {
			// 查找第一个未完成的步骤
			if (this.orderSteps && this.orderSteps.length > 0) {
				const unfinishedStep = this.orderSteps.find(step => step.status === 0)
				if (unfinishedStep) {
					// 找到未完成的步骤，自动选择对应的认证类型
					this.selectedType = unfinishedStep.step_type
					this.availableTypes = [unfinishedStep.step_type]
				} else {
					// 所有步骤都完成了，根据current_step确定
					if (this.currentOrder.current_step === 1) {
						this.selectedType = 'car'
						this.availableTypes = ['car']
					} else if (this.currentOrder.current_step === 2) {
						this.selectedType = 'hotel'
						this.availableTypes = ['hotel']
					} else if (this.currentOrder.current_step === 3) {
						this.selectedType = 'confidential'
						this.availableTypes = ['confidential']
					} else {
						// 默认车费认证
						this.selectedType = 'car'
						this.availableTypes = ['car']
					}
				}
			} else {
				// 没有步骤信息，根据current_step确定
				if (this.currentOrder.current_step === 1) {
					this.selectedType = 'car'
					this.availableTypes = ['car']
				} else if (this.currentOrder.current_step === 2) {
					this.selectedType = 'hotel'
					this.availableTypes = ['hotel']
				} else if (this.currentOrder.current_step === 3) {
					this.selectedType = 'confidential'
					this.availableTypes = ['confidential']
				} else {
					// 默认车费认证
					this.selectedType = 'car'
					this.availableTypes = ['car']
				}
			}
		},
		selectType(type) {
			// 只允许选择当前应该进行的认证类型
			if (this.availableTypes.includes(type)) {
				this.selectedType = type
			} else {
				this.$toast.fail(this.$t('certification.selectCertTypeByProgress'))
			}
		},
		goNext() {
			if (!this.selectedType) {
				this.$toast.fail(this.$t('certification.pleaseSelectCertType'))
				return
			}
			// 跳转到认证页面，不传递certType，让认证页面根据订单进度自动判断
			this.$router.push({
				path: '/Certification',
				query: {
					id: this.beautyId
				}
			})
		},
		switchTab(tabName) {
			this.activeTab = tabName
			// 这里可以添加跳转逻辑
			if (tabName === 'info') {
				// 跳转到信息页面
			} else if (tabName === 'video') {
				// 跳转到视频页面
			} else if (tabName === 'square') {
				// 跳转到广场页面
			} else if (tabName === 'auth') {
				// 跳转到认证页面
			} else if (tabName === 'my') {
				this.$router.push({ path: '/Mine' })
			}
		}
	}
}
</script>

<style scoped>
.app-container {
	position: relative;
	height: 100vh;
	background: #000;
	color: white;
	overflow: hidden;
	font-family: Arial, sans-serif;
}

/* 顶部标题栏 */
.header-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 25px 16px;
	background: url(/img/header.svg) no-repeat 50%/100%;
	position: relative;
	z-index: 10;
	height: 3rem;
}

.back-btn {
	font-size: 28px;
	background: none;
	border: none;
	color: white;
	cursor: pointer;
}

.title-center {
	text-align: center;
	flex: 1;
}

.main-title {
	font-size: 30px;
	font-weight: bold;
}

.header-right {
	width: 40px;
}

/* 背景图 */
.bg-image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: url('http://www.desire-club.top/xuanfei/20241022/7bf5bf8a20b306cf1706f8d9eab4b76c.jpg') no-repeat center center;
	background-size: cover;
	filter: blur(2px);
	opacity: 0.4;
	z-index: 0;
}

/* 内容区域 */
.content-wrapper {
	position: relative;
	z-index: 5;
	padding: 20px 16px;
	margin-top: 20px;
	overflow-y: auto;
	max-height: calc(100vh - 200px);
}

/* 中间内容容器（灰色半透明背景） */
.middle-container {
	background: rgba(128, 128, 128, 0.3);
	border-radius: 0 0 20px 20px;
	padding: 40px;
	margin-bottom: 30px;
	backdrop-filter: blur(10px);
}

/* VIP横幅 */
.vip-banner {
	display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(90deg,#df35ad,#4f1db5);
    padding: 3.2vw 3.733vw;
    border-radius: 2.133vw 2.133vw 0 0;
    margin-bottom: 2.667vw;
	box-shadow: 2vw 0vw 0.533vw rgba(0, 0, 0,0);
}

.vip-text {
	font-size: 75px;
	font-weight: 900;
	color: #e3d3aa;
	text-shadow: 2vw 0vw 0.533vw rgba(0, 0, 0, 0.3);
	letter-spacing: 2px;
}

.vip-icon {
	font-size: 56px;
	filter: drop-shadow(0.267vw 0.267vw 0.533vw rgba(0, 0, 0, 0.3));
    margin-left: 5px;
    font-style: inherit;
}

/* 官方合作数据按钮 */
.official-btn {
	width: 59%;
    background: #ec4899;
    color: white;
    border: none;
    border-radius: 6.6vw;
    padding: 2.4vw 2.667vw;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.6vw;
    font-size: 2.4vw;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 0.267vw 1.067vw rgba(236, 72, 153, 0.4);
    transition: all 0.3s;
    margin: 20px auto;
}

.official-btn:active {
	transform: scale(0.98);
	box-shadow: 0 1px 4px rgba(236, 72, 153, 0.5);
}

.official-icon {
	font-size: 34px;
}

.official-text {
	font-size: 34px;
}

/* 认证选项网格 */
.certification-grid {
	display: flex;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 20px;
	margin-top: 40px;
}

.cert-item {
	background: rgba(60, 60, 60, 0.4);
	border: 2px solid rgba(139, 139, 139, 0.5);
	border-radius: 12px;
	padding: 20px 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.3s;
	min-height: 250px;
	backdrop-filter: blur(5px);
	width: 28%;
    margin: auto;
}

.cert-item.active {
	background: rgba(236, 72, 153, 0.1);
	border-color: #ec4899;
	box-shadow: 0 0 15px rgba(236, 72, 153, 0.5);
	transform: scale(1.03);
}

.cert-item:active {
	transform: scale(0.97);
}

.cert-item.disabled {
	opacity: 0.5;
	cursor: not-allowed;
	pointer-events: none;
	position: relative;
}

.cert-item.disabled .cert-icon,
.cert-item.disabled .cert-text {
	opacity: 0.5;
}

.disabled-overlay {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(0, 0, 0, 0.7);
	color: #999;
	padding: 8px 16px;
	border-radius: 8px;
	font-size: 24px;
	z-index: 10;
	white-space: nowrap;
}

.cert-icon {
	font-size: 40px;
	margin-bottom: 10px;
	filter: brightness(1.2) saturate(0.8);
}

.cert-text {
	font-size: 28px;
	text-align: center;
	color: white;
}

/* 在线匹配 */
.online-match {
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(60, 60, 60, 0.5);
	border-radius: 10px;
	padding: 20px 16px;
	gap: 10px;
	backdrop-filter: blur(5px);
	width: 94%;
    margin: 0 auto;
    margin-bottom: 20px;
}

.location-icon {
	font-size: 30px;
	color: #ec4899;
}

.match-text {
	color: white;
	font-size: 30px;
	text-align: center;
}

/* 下一步按钮 */
.next-btn {
	width: 100%;
	background: linear-gradient(90deg,#df35ad,#4f1db5);
	color: white;
	border: none;
	border-radius: 16px;
	padding: 24px;
	font-size: 28px;
	cursor: pointer;
	box-shadow: 0 4px 12px rgba(236, 72, 153, 0.3);
	transition: all 0.3s;
}

.next-btn:active {
	transform: scale(0.98);
	box-shadow: 0 2px 8px rgba(236, 72, 153, 0.4);
}

/* 底部导航栏 */
.footer-nav {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: none;
	border-top: 2px solid #ec4899;
	display: flex;
	justify-content: space-around;
	padding: 8px 0;
	z-index: 100;
}

.nav-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8px 0;
	font-size: 16px;
	color: #fff;
	cursor: pointer;
	transition: color 0.2s;
	background: none;
	border: none;
}

.nav-item.active {
	color: #ec4899;
}

.nav-icon {
	font-size: 28px;
	margin-bottom: 6px;
}

.nav-text {
	font-size: 28px;
}
</style>
